import { useIsTreatmentVariantByUser } from "../../utils";

export const useFormation = () => {
  const EXPERIMENT_KEY = "tc-437-use-formation";

  return useIsTreatmentVariantByUser(EXPERIMENT_KEY);
};
